import { render, staticRenderFns } from "./global-solution-without-sidebar.layout.vue?vue&type=template&id=a47ad56c"
import script from "./global-solution-without-sidebar.layout.ts?vue&type=script&lang=ts&external"
export * from "./global-solution-without-sidebar.layout.ts?vue&type=script&lang=ts&external"
import style0 from "./global-solution-without-sidebar.layout.vue?vue&type=style&index=0&id=a47ad56c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports